import { deleteClient } from "../../../../services/Api/customerService";
import { usePartnerHomeCustomerStore } from "../../../../stores/Cac/Partner/partnerHomeCustomer";
import { showToastError, showToastSuccess } from "../../../../services/Toasts/toasts";

const PartnerDeleteCustomer = () => {
  // Store
  const { choiceModal, setChoiceModal, idCustomer, setIdCustomer } =
    usePartnerHomeCustomerStore();

  const handleReset = () => {
    setChoiceModal("");
    setIdCustomer(0);
  };

  const handleDeleteClient = async (id: number) => {
    const success = await deleteClient(id);
    if (success) {
      handleReset();
      showToastSuccess("La suppression a bien été effectuée !");
    } else {
      showToastError("La suppression a échoué !");
      handleReset();
    }
  };

  return (
    choiceModal === "delete" && (
      <>
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-3 outline-hidden focus:outline-hidden sm:p-6">
          <div className="relative mx-auto w-full max-w-lg">
            {/* Content */}
            <div className="relative flex w-full flex-col rounded-2xl border-0 bg-white shadow-2xl outline-hidden focus:outline-hidden">
              {/* Header */}
              <div className="w-full rounded-t-xl bg-white p-4">
                <h4 className="flex items-center gap-2 text-lg font-semibold text-gray-700 sm:text-xl">
                  <svg className="w-5 h-6 " fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Supprimer le dossier client
                </h4>
              </div>
              {/* Body */}
              <div className="w-full flex flex-col items-center justify-center text-grey-trio">
                <div className="mb-6 flex w-full flex-col items-center justify-center px-5">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                    Confirmation de suppression
                  </h3>
                  <p className="text-md text-gray-600 text-center">
                    Êtes-vous sûr de vouloir supprimer ce dossier client ?
                  </p>
                  <p className="text-sm text-gray-500 text-center mt-2 italic">
                    Cette action est irréversible et supprimera définitivement le dossier.
                  </p>
                </div>
              </div>

              {/* Footer */}
              <div className="flex items-center justify-end gap-3 rounded-b-2xl bg-white p-3">
                <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-500 transition-all duration-200 hover:bg-gray-200 sm:flex-none"
                  type="button"
                  onClick={() => handleReset()}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  Annuler
                </button>
                <button
                  className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:bg-red-700 hover:shadow-xl sm:flex-none sm:hover:scale-105"
                  type="button"
                  onClick={() => handleDeleteClient(idCustomer)}
                >
                  <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Supprimer
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    )
  );
};

export default PartnerDeleteCustomer;
